import HowItWorksContainer from './HowItWorksContainer';

export default HowItWorksContainer;
